"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationEligibilityPaths = exports.FindShiftsPaths = exports.DashboardPaths = exports.getRouteFromPath = exports.routeToPageName = exports.Routes = exports.PageName = void 0;
var PageName;
(function (PageName) {
    PageName["Dashboard"] = "Dashboard";
    PageName["MySchedule"] = "MySchedule";
    PageName["FindShifts"] = "FindShifts";
    PageName["Swap"] = "Swap";
    PageName["LocationEligibility"] = "LocationEligibility";
})(PageName = exports.PageName || (exports.PageName = {}));
var Routes;
(function (Routes) {
    // Base routes
    Routes["Index"] = "/shifts";
    Routes["FindShifts"] = "/shifts/schedule/find";
    Routes["FindShiftsNew"] = "/shifts/find";
    Routes["MySchedule"] = "/shifts/schedule";
    Routes["Swap"] = "/shifts/swap";
    Routes["LocationEligibility"] = "/shifts/locationEligibility";
    Routes["Timecard"] = "/shifts/timecard";
    Routes["MyScheduleTimecard"] = "/shifts/schedule/timecard";
    // Other AtoZ Routes
    Routes["Pay"] = "/pay";
    Routes["RequestTimeOff"] = "/time/request";
    Routes["ViewTimeOffRequest"] = "/time/history";
    Routes["NotificationPreferences"] = "/notification_preferences";
    // Routes maintained for backwards compatibility - do not use these within the app navigation!
    Routes["Dashboard"] = "/shifts/dashboard";
    Routes["FindShiftsLocationEligibility"] = "/shifts/schedule/find/locationEligibility";
    Routes["FindShiftsDashboard"] = "/shifts/dashboard/schedule/find/:locationName";
    Routes["FindShiftsDashboardBase"] = "/shifts/dashboard/schedule/find";
    Routes["DashboardLocationEligibility"] = "/shifts/dashboard/locationEligibility";
    Routes["FindShiftsWithSite"] = "/shifts/schedule/find/:siteId";
})(Routes = exports.Routes || (exports.Routes = {}));
exports.routeToPageName = (_a = {},
    _a[Routes.Index] = PageName.Dashboard,
    _a[Routes.FindShifts] = PageName.FindShifts,
    _a[Routes.FindShiftsNew] = PageName.FindShifts,
    _a[Routes.MySchedule] = PageName.MySchedule,
    _a[Routes.Swap] = PageName.Swap,
    _a[Routes.LocationEligibility] = PageName.LocationEligibility,
    _a[Routes.Dashboard] = PageName.Dashboard,
    _a[Routes.FindShiftsLocationEligibility] = PageName.LocationEligibility,
    _a[Routes.FindShiftsDashboard] = PageName.FindShifts,
    _a[Routes.FindShiftsDashboardBase] = PageName.FindShifts,
    _a[Routes.FindShiftsWithSite] = PageName.FindShifts,
    _a[Routes.DashboardLocationEligibility] = PageName.LocationEligibility,
    _a[Routes.Timecard] = PageName.Dashboard,
    _a[Routes.MyScheduleTimecard] = PageName.MySchedule,
    _a);
var getRouteFromPath = function (path) {
    if (!path) {
        return undefined;
    }
    // Only routes including /schedule/find have a path param
    // TODO: the path param should be a query var instead,
    // at which point this can be removed
    if (path.includes('schedule/find') &&
        !path.includes('locationEligibility')) {
        return PageName.FindShifts;
    }
    return exports.routeToPageName[path];
};
exports.getRouteFromPath = getRouteFromPath;
exports.DashboardPaths = [Routes.Index, Routes.Dashboard, Routes.Timecard];
exports.FindShiftsPaths = [
    Routes.FindShifts,
    Routes.FindShiftsNew,
    Routes.FindShiftsWithSite,
    Routes.FindShiftsDashboard,
    Routes.FindShiftsDashboardBase
];
exports.LocationEligibilityPaths = [
    Routes.LocationEligibility,
    Routes.DashboardLocationEligibility,
    Routes.FindShiftsLocationEligibility
];
